import { appAssets } from "./assets";

export const homeSliderItems = [
    {
        id: 1,
        title: "La Ligue des 2 Zéros en images",
        description: "Revivez les meilleurs moments du championnat.",
        image: appAssets.homeSlider.slide1,
    },
    {
        id: 2,
        title: "Des équipes engagées et passionnées",
        description: "Découvrez les clubs et leurs couleurs.",
        image: appAssets.homeSlider.slide2,
    },
    {
        id: 3,
        title: "Événements, football et convivialité",
        description: "Une ligue qui rassemble autour du sport.",
        image: appAssets.homeSlider.slide3,
    },
    {
        id: 4,
        title: "Suivez toute l’actualité de la saison",
        description: "Résultats, classements et annonces officielles.",
        image: appAssets.homeSlider.slide4,
    },
];